function TailwindDemo() {
  return (
    <div className="flex flex-column align-items-center">
      <h2 className="text-primary text-xl mb-3">Tailwindデモ</h2>
      <p className="text-lg mb-4">
        Tailwind CSSのスタイリングとプレフィックスの動作確認
      </p>

      <div className="my-5">
        <h3 className="text-lg font-medium mb-3">標準のTailwind構文</h3>
        <div className="flex justify-center gap-4 my-4">
          <div className="w-[5rem] h-[3rem] bg-blue-500 flex items-center justify-center text-white rounded">
            w-[5rem]
          </div>
          <div className="w-[8rem] h-[3rem] bg-green-500 flex items-center justify-center text-white rounded">
            w-[8rem]
          </div>
          <div className="w-[10rem] h-[3rem] bg-yellow-500 flex items-center justify-center text-white rounded">
            w-[10rem]
          </div>
        </div>
      </div>

      <div className="my-5">
        <h3 className="text-lg font-medium mb-3">プレフィックス付きTailwind</h3>
        <div className="tw-flex tw-justify-center tw-gap-4 tw-my-4">
          <div className="tw-w-20 tw-h-12 tw-bg-blue-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-rounded">
            tw-w-20
          </div>
          <div className="tw-w-32 tw-h-12 tw-bg-green-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-rounded">
            tw-w-32
          </div>
          <div className="tw-w-24 tw-h-12 tw-bg-red-500 tw-flex tw-items-center tw-justify-center tw-text-white tw-rounded">
            tw-w-24
          </div>
        </div>
      </div>

      <div className="my-5">
        <h3 className="text-lg font-medium mb-3">レスポンシブデザイン</h3>
        <div className="grid">
          <div className="col-12 sm:col-6 md:col-4 lg:col-3 p-2">
            <div className="bg-primary h-3rem flex align-items-center justify-content-center text-white">
              レスポンシブ1
            </div>
          </div>
          <div className="col-12 sm:col-6 md:col-4 lg:col-3 p-2">
            <div className="bg-primary-600 h-3rem flex align-items-center justify-content-center text-white">
              レスポンシブ2
            </div>
          </div>
          <div className="col-12 sm:col-6 md:col-4 lg:col-3 p-2">
            <div className="bg-primary-400 h-3rem flex align-items-center justify-content-center text-white">
              レスポンシブ3
            </div>
          </div>
          <div className="col-12 sm:col-6 md:col-4 lg:col-3 p-2">
            <div className="bg-primary-200 h-3rem flex align-items-center justify-content-center text-black">
              レスポンシブ4
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TailwindDemo
